"use client";

import React from "react";

import { OrderbookTable } from "#/components/OrderbookTable/OrderbookTable";
import { useMarketIndexPrice } from "#/store/app/indexPrices/marketIndexPrice";
import { useOption } from "#/store/options/tradePanel/option";
import { useOptionLimitPrice } from "#/store/options/tradePanel/optionLimitPrice";
import {
  type OrderbookEntry,
  type TransformedOrderbook,
} from "#/types/orderbook";

export interface OptionsOrderbookProps {
  orders?: TransformedOrderbook;
}

export const OptionsOrderbook: React.FC<OptionsOrderbookProps> = ({
  orders,
}) => {
  const { setOptionLimitPrice } = useOptionLimitPrice();
  const { marketIndexPrice } = useMarketIndexPrice();
  const { option } = useOption();

  const handleSelectRow = ({ price }: OrderbookEntry) => {
    setOptionLimitPrice(String(price));
  };

  if (!orders || typeof option?.markPrice !== "number") return null;

  return (
    <OrderbookTable
      {...orders}
      variant="options"
      price={option?.markPrice}
      indexPrice={marketIndexPrice}
      onSelectRow={handleSelectRow}
    />
  );
};
